export default __webpack_public_path__ + "static/media/Spain.9939f8bd.png";